<div class="new-content" *ngIf="!contentLoaded; else contentBlock">
  <loading-line *ngIf="pane.display_mode === 'row'" height="40px" width="100%"></loading-line>
</div>

<app-skeleton *ngIf="showSkeleton && pane.display_mode !== 'row'" [stats]="'my-classes-schedule'"></app-skeleton>

<ng-template #contentBlock>
  <div *ngIf="!showSkeleton" class="content" [class.cell-row]="pane.display_mode === 'row'">
    <app-chapter [link]="blockTitle?.add_link" [title]="blockTitle.title"></app-chapter>

    <app-filter-content
      *ngIf="pane.display_mode === 'row'"
      [top]="isTeacher"
      [tabs]="categoryTabs"
      [activeTab]="selectedTab"
      (onSelect)="onSelectItem($event)">
      <ng-template action [ngIf]="isTeacher">
        <on-ui-button
          *ngIf="!deviceService.isMobile()"
          label="my-classes.actions.schedule-class"
          class="poutline"
          (onclick)="onCheckScheduleMeeting()">
        </on-ui-button>

        <div *ngIf="deviceService.isMobile()" class="create-item" (click)="onCheckScheduleMeeting()">
          <div class="action-icon-wrap">
            <app-icon [width]="10" [height]="10" icon="plus"></app-icon>
          </div>
        </div>
      </ng-template>
    </app-filter-content>

    <div *ngIf="pane.loading">
      <loading-line *ngIf="pane.display_mode === 'row'" height="40px" width="100%"></loading-line>
    </div>

    <div *ngIf="filteredEvents.length" class="scroll">
      <div class="schedule-list" [class.cell-row]="pane.display_mode === 'row'">
        <div *ngFor="let meeting of filteredEvents; let i = index; trackBy: trackMeetingByFn" class="schedule-item">
          <app-schedule-mini [display_mode]="pane.display_mode" [me]="me" (changed)="onChanged()" [meeting]="meeting">
          </app-schedule-mini>
        </div>
      </div>

      <div class="pagination-wrap" *ngIf="pane.display_mode === 'row' && pane.pagination?.totalPages > 1">
        <app-paginator [pagination]="pane.pagination" (pageChanged)="loadPage($event)"></app-paginator>
      </div>
    </div>

    <app-empty
      *ngIf="showEmptyContent && pane.loaded"
      [empty]="emptyContent"
      (onClick)="onCheckScheduleMeeting()"></app-empty>
    <ng-container
      *ngIf="!filteredEvents.length && pane.display_mode === 'row'"
      [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-no-content-stub
    (click)="onCheckScheduleMeeting()"
    [icon]="'stub-schedule'"
    [text]="isTeacher ? 'my-classes.stub.stub1' : 'my-classes.stub.stub1_1'">
  </app-no-content-stub>
</ng-template>

<ng-template [ngIf]="meetingFormOpened">
  <app-modal *ngIf="deviceService.isDesktop(); else mobileMeetingForm" [canClose]="false" (closed)="closeMeetingForm()">
    <app-modal-body>
      <app-meeting-form-wrapper [caller]="'app-my-classes-schedule'"></app-meeting-form-wrapper>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileMeetingForm>
    <app-mobile-modal (closed)="closeMeetingForm()">
      <app-mobile-modal-title>{{ 'lingo2-forms.meetings.form-title' | customLocale }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-meeting-form-wrapper [caller]="'app-my-classes-schedule'"></app-meeting-form-wrapper>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>

<ng-template [ngIf]="openResumePlanModal">
  <app-payment-wizard-dialog [plan]="plan" (closed)="toggleResumePlan()"></app-payment-wizard-dialog>
</ng-template>
